export const IMAGE_FILETYPE: string = "IMAGE_PLAIN";
export const PREVIEW_FILETYPE: string = "PREVIEW_IMAGE";
export const INIT_LOAD_AMOUNT = 20;
export const LAZY_LOAD_AMOUNT = 10;
